import React, { useEffect, useState } from 'react';
import {
  HomeContainer,
  HomeContent,
  HomeIcon,
  HomeTitle,
  HomeParapraph,
  HomeFooter
} from './styles';
import { VscPinned } from 'react-icons/vsc';
import { DefaultLargeButton, PrimaryLargeButton } from '../../../components/Buttons/styles';
import colors from '../../../assets/styles/colors';
import { exceptionSteps } from '../../../helpers/enum';
import { useHistory, useLocation } from 'react-router-dom';
import { skipException, verifyException } from '../../../services/exceptions';
import Loader from '../../../components/Loader';
import { AlertContainer, AlertIcon } from '../../../components/Alert/styles';
import { BsExclamation } from 'react-icons/bs';
import { ReactComponent as Spinner} from '../../../assets/images/spinner.svg';

const HomePage = ({ setActiveStep }) => {
  const location = useLocation();
  const history = useHistory();
  const [disabledButton, setDisabledButton] = useState(false);
  const [isLoading, setIsLoading] = useState(false);

  async function initializedStateComponent() {
    try {
      const response = await verifyException(location.idCredit);
      setDisabledButton(response.data.bloqueada);
    } catch (error) {
      
    }
  }

  async function giveException() {
    try {
      setIsLoading(true);

      const data = {
        idCredito: location.idCredit
      }

      await skipException(data);
      setIsLoading(false);
      history.push({
        pathname: '/admin/ap-secure',
        idCredit: location.idCredit
      })
    } catch (error) {
      
    }
  }

  useEffect(() => {
    giveException();
  }, [])

  return ( <Spinner></Spinner>
    /*
    <HomeContainer>
      <HomeContent>
        {disabledButton && (
          <AlertContainer border={colors.bgTertiary} style={{marginBottom :20, alignItems: 'flex-start'}} background={colors.bgTertiaryShadow}>
            <AlertIcon background={colors.bgTertiary}>
              <BsExclamation color={colors.textPrimary} />
            </AlertIcon>
            <div>
            <p style={{fontWeight: 'bold', color: colors.textPrimary}}>Bloqueo por excepción</p>
            <span style={{ fontWeight: 'normal', color: colors.textPrimary }}>Por el momento no puedes solicitar excepciones, ya que tu oficina tiene pendiente la resolución de una o varias excepciones en estado vencida.</span>
            </div>
          </AlertContainer>
        )}
        <HomeIcon><VscPinned color={colors.textPrimary} size={32} /></HomeIcon>
        <HomeTitle>Solicitud de excepción</HomeTitle>
        <HomeParapraph>¿Para la socilitud en curso, requiere solicitar excepciones?</HomeParapraph>
        <HomeFooter>
          <DefaultLargeButton type="button" id="button" onClick={() => giveException()}>Continuar sin excepción</DefaultLargeButton>
          <PrimaryLargeButton type="button" id="button" disabled={disabledButton} onClick={() => setActiveStep(exceptionSteps.EXCEPTIONS)}>Tramitar excepción</PrimaryLargeButton>
        </HomeFooter>
        {isLoading && <Loader />}
      </HomeContent>
    </HomeContainer>
  */)
}

export default HomePage;
